var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isDarenPartner)?_c('div',{staticClass:"tipsBox mb-10 flex flex-align-center"},[_c('i',{staticClass:"el-icon-info iconfont-color"}),_c('span',{staticClass:"font-h6-regular yx-color-text-primary"},[_vm._v("注意：您正在协助达人招商进行操作，本次操作将会同步到达人招商选品小程序中，请与相应达人招商确认后进行操作！")])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }